import { Radio as MuiRadio, RadioProps } from '@mui/material';

export const Radio = (props: RadioProps) => <MuiRadio {...props} />;
